import { getCampaignPolicies } from '@/services/campaign.service'
import { useQuery } from '@tanstack/vue-query'

interface Options {
  enabled?: boolean
}

export function useCampaignPolicies(options: Options = { enabled: true }) {
  return useQuery({
    queryKey: ['campaign-policies'],
    queryFn: getCampaignPolicies,
    enabled: options.enabled,
    staleTime: Number.POSITIVE_INFINITY,
    cacheTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
